// Leads (Opportunities) Management Permissions

export const LEADS_INDEX = 140;
export const LEADS_STORE = 141;
export const LEADS_UPDATE = 142;
export const LEADS_DESTROY = 143;
export const LEADS_RESTORE = 1399;
export const LEADS_EXPORT = 1346;
export const LEADS_INTERACTIONS_INDEX = 144;
export const LEADS_INTERACTIONS_STORE = 145;
export const LEADS_DEALS_INDEX = 146;
// export const LEADS_FAVOURITES_INDEX = 145;
export const LEADS_SHOW = LEADS_INDEX;

// Qualification funnel — registered by the amer-laravel migration
// 2026_08_05_000008_add_crm_structure_refactor_permissions. The ids below are the
// central-assigned approval numbers and must be confirmed against the central
// permission-key registry before release.
//
// Deliberately separate from LEADS_UPDATE: qualifying decides whether a lead is
// worth pursuing, while converting writes a contact, a company and a deal — a
// junior agent may do the first without being allowed the second.
/** leads.qualify */
export const LEADS_QUALIFY = 1440;
/** leads.convert */
export const LEADS_CONVERT = 1441;

// CRM operations layer — registered by the amer-laravel migration
// 2026_08_06_000004_add_crm_operations_permissions. Ids below are the
// central-assigned approval numbers.
//
// Merging is separate from LEADS_UPDATE because it is the one CRM action that
// destroys a record: one lead's interactions, reminders and history move onto
// another and the loser is closed for good. Correcting a phone number should not
// imply being allowed to do that.
/** leads.merge */
export const LEADS_MERGE = 1453;
